<div class="admin-companies">
    <!-- Header -->
    <div class="page-header">
        <div>
            <h2>Gestion des Sociétés</h2>
            <p class="text-muted">Gérez toutes les sociétés de la plateforme</p>
        </div>
    </div>

    <!-- Filters -->
    <div class="filters-card">
        <div class="row g-3">
            <div class="col-md-4">
                <div class="search-box">
                    <i class="bi bi-search"></i>
                    <input type="text" class="form-control" placeholder="Rechercher une société..." 
                            [(ngModel)]="searchTerm" (ngModelChange)="onSearch()">
                </div>
            </div>
            <div class="col-md-3">
                <select class="form-select" [(ngModel)]="filterCategory" (ngModelChange)="applyFilters()">
                    <option value="">Toutes les catégories</option>
                    <option value="Développement web">Développement web</option>
                    <option value="Informatique">Informatique</option>
                    <option value="Architecte">Architecte</option>
                    <option value="Avocat">Avocat</option>
                </select>
            </div>
            <div class="col-md-3">
                <select class="form-select" [(ngModel)]="filterStatus" (ngModelChange)="applyFilters()">
                    <option value="">Tous les statuts</option>
                    <option value="visible">Visible</option>
                    <option value="hidden">Masqué</option>
                </select>
            </div>
            <div class="col-md-2">
                <button class="btn btn-outline-secondary w-100" (click)="resetFilters()">
                    <i class="bi bi-arrow-clockwise me-2"></i>Reset
                </button>
            </div>
        </div>
    </div>

    <!-- Stats Cards -->
    <div class="row g-4 mb-4">
        <div class="col-md-4">
            <div class="stat-card stat-primary">
                <div class="stat-icon">
                    <i class="bi bi-building"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.total }}</h3>
                    <p>Total Sociétés</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="stat-card stat-success">
                <div class="stat-icon">
                    <i class="bi bi-eye"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.visible }}</h3>
                    <p>Visibles</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="stat-card stat-info">
                <div class="stat-icon">
                    <i class="bi bi-star"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.averageRating }}/5</h3>
                    <p>Note moyenne</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="table-card">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Société</th>
                        <th>Propriétaire</th>
                        <th>Catégorie</th>
                        <th>Note</th>
                        <th>Vues</th>
                        <th>Statut</th>
                        <th>Créée le</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for(company of paginatedCompanies; track company._id) {
                        <tr>
                            <td>
                                <div class="company-cell">
                                    <div class="company-avatar">
                                        {{ company.companyName.charAt(0) }}
                                    </div>
                                    <div>
                                        <div class="company-name">{{ company.companyName }}</div>
                                        <div class="company-email">{{ company.companyEmail }}</div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="owner-cell">
                                    <div>{{ company.owner.firstName }} {{ company.owner.lastName }}</div>
                                    <small class="text-muted">{{ company.owner.email }}</small>
                                </div>
                            </td>
                            <td>
                                <span class="badge-category">{{ company.category }}</span>
                            </td>
                            <td>
                                <div class="rating">
                                    <i class="bi bi-star-fill"></i>
                                    <span>{{ company.averageRating || 0 }}</span>
                                </div>
                            </td>
                            <td>
                                <span class="views">{{ company.totalViews }}</span>
                            </td>
                            <td>
                                <span class="badge" [class.badge-success]="company.isVisible" 
                                        [class.badge-secondary]="!company.isVisible">
                                    {{ company.isVisible ? 'Visible' : 'Masqué' }}
                                </span>
                            </td>
                            <td>
                                <small>{{ company.createdAt | date:'dd/MM/yyyy' }}</small>
                            </td>
                            <td>
                                <div class="action-buttons">
                                    <button class="btn-action btn-view" (click)="viewCompany(company)" title="Voir">
                                        <i class="bi bi-eye"></i>
                                    </button>
                                    <button class="btn-action btn-edit" (click)="editCompany(company)" title="Éditer">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-action btn-toggle" 
                                            (click)="toggleVisibility(company)" 
                                            [title]="company.isVisible ? 'Masquer' : 'Rendre visible'">
                                        <i class="bi" [class.bi-eye-slash]="company.isVisible" 
                                            [class.bi-eye]="!company.isVisible"></i>
                                    </button>
                                    <button class="btn-action btn-delete" (click)="deleteCompany(company)" title="Supprimer">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="8" class="text-center py-5">
                                <i class="bi bi-inbox" style="font-size: 3rem; color: #cbd5e1;"></i>
                                <p class="mt-3 text-muted">Aucune société trouvée</p>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="table-footer">
            <div class="showing-info">
                Affichage de {{ (currentPage - 1) * pageSize + 1 }} à 
                {{ Math.min(currentPage * pageSize, filteredCompanies.length) }} 
                sur {{ filteredCompanies.length }} résultats
            </div>
            <div class="pagination">
                <button class="btn-page" (click)="previousPage()" [disabled]="currentPage === 1">
                    <i class="bi bi-chevron-left"></i>
                </button>
                @for(page of getPages(); track page) {
                    <button class="btn-page" [class.active]="page === currentPage" 
                            (click)="goToPage(page)">
                        {{ page }}
                    </button>
                }
                <button class="btn-page" (click)="nextPage()" [disabled]="currentPage === totalPages">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>